import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";

const contacts = [
    {
        id: 1,
        name: "Jean Dupont",
        organization: "URSSAF",
        email: "jean.dupont@urssaf.fr",
        phone: "+33611223344",
    },
    {
        id: 2,
        name: "Marie Curie",
        organization: "CPAM",
        email: "marie.curie@cpam.fr",
        phone: "+33655667788",
    },
    {
        id: 3,
        name: "Albert Camus",
        organization: "CAF",
        email: "albert.camus@caf.fr",
        phone: "+33699887766",
    },
    {
        id: 4,
        name: "Louise Michel",
        organization: "MSA",
        email: "louise.michel@msa.fr",
        phone: "+33644332211",
    },
];

const ElementList = ({ contact }) => {
    const navigate = useNavigate();

    return (
        <li
            className="pt-2 pb-2 sm:pt-4 cursor-pointer hover:bg-gray-50 transition"
            onClick={() => {
                navigate("/activity/contact/" + contact.id);
            }}
        >
            <div className="flex items-center space-x-4 rtl:space-x-reverse">
                <div className="shrink-0">
                    <img
                        className="w-8 h-8 rounded-full"
                        src="https://media.istockphoto.com/id/1389348844/fr/photo/plan-de-studio-dune-belle-jeune-femme-souriante-debout-sur-un-fond-gris.jpg?s=612x612&w=0&k=20&c=VGipX3a8xrbYuXTNm_61pFuzpGdAO9lwt2xnVUd7Khs="
                        alt="avatar"
                    />
                </div>
                <div className="flex-1 min-w-0">
                    <p className="m-0 text-sm font-medium text-gray-900 truncate">
                        {contact.name} - {contact.organization}
                    </p>
                    <p className="m-0 text-sm text-gray-500 truncate">
                        {contact.email}
                    </p>
                </div>
                <div className="text-sm text-gray-700">{contact.phone}</div>
            </div>
        </li>
    );
};

export const ListContacts = () => {
    const [search, setSearch] = useState("");
    const [showSidebar, setShowSidebar] = useState(false);

    // Filtrage par recherche
    const filteredContacts = contacts.filter(
        (contact) =>
            contact.name.toLowerCase().includes(search.toLowerCase()) ||
            contact.organization.toLowerCase().includes(search.toLowerCase())
    );
    const handleCreateContact = () => {
    };
    // Grouper par première lettre du nom
    const groupedContacts = filteredContacts.reduce((acc, contact) => {
        const firstLetter = contact.name[0].toUpperCase();
        if (!acc[firstLetter]) acc[firstLetter] = [];
        acc[firstLetter].push(contact);
        return acc;
    }, {});

    const sortedLetters = Object.keys(groupedContacts).sort();

    return (
        <div className="mx-auto p-4">
            <div className="flex justify-end items-center mb-4">
                <button
                    onClick={() => setShowSidebar(true)}
                    className="p-2 rounded-full hover:bg-green-100 transition"
                    title="Ajouter un contact"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-5 h-5 text-green-700"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M12 4v16m8-8H4"
                        />
                    </svg>
                </button>
                <button
                    onClick={() => navigate("")}
                    className="p-2 rounded-full hover:bg-green-100 transition"
                    title="Exporter"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-5 h-5 text-green-700"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 15V3"
                        />
                    </svg>
                </button>
            </div>
            <input
                type="text"
                placeholder="Rechercher un contact..."
                className="w-full p-2 mb-6 border border-gray-300 rounded-sm"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            />
            {sortedLetters.length === 0 ? (
                <p className="text-center text-gray-500">
                    Aucun contact trouvé
                </p>
            ) : (
                sortedLetters.map((letter) => (
                    <div key={letter} className="mb-6">
                        <h2 className="text-lg font-bold text-gray-700 border-b border-gray-300 pb-1 mb-2">
                            {letter}
                        </h2>
                        <ul className="divide-y divide-gray-200">
                            {groupedContacts[letter].map((contact) => (
                                <ElementList
                                    key={contact.id}
                                    contact={contact}
                                />
                            ))}
                        </ul>
                    </div>
                ))
            )}
            {showSidebar && (
                <SidebarForm onClose={() => setShowSidebar(false)} />
            )}
        </div>
    );
};

const SidebarForm = ({ onClose }) => {
    return (
        <div className="fixed inset-y-0 right-0 w-full max-w-md bg-white shadow-lg p-6 overflow-y-auto z-50">
            <button
                onClick={onClose}
                className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
                aria-label="Fermer la sidebar"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                    />
                </svg>
            </button>
            <h2 className="text-xl font-bold mb-4">
                Ajouter / Modifier un contact
            </h2>
            <form className="space-y-4">
                <div>
                    <label className="block mb-1">Titre</label>
                    <select className="w-full border p-2 rounded-sm">
                        <option>M.</option>
                        <option>Mme</option>
                        <option>Autres</option>
                    </select>
                </div>
                <div>
                    <label className="block mb-1">Organisme</label>
                    <input
                        className="w-full border p-2 rounded-sm"
                        type="text"
                        required
                    />
                </div>
                <div>
                    <label className="block mb-1">Nom</label>
                    <input
                        className="w-full border p-2 rounded-sm"
                        type="text"
                        required
                    />
                </div>
                <div>
                    <label className="block mb-1">Prénom</label>
                    <input
                        className="w-full border p-2 rounded-sm"
                        type="text"
                        required
                    />
                </div>
                <div>
                    <label className="block mb-1">Téléphone</label>
                    <input
                        className="w-full border p-2 rounded-sm"
                        type="text"
                        required
                    />
                </div>
                <div>
                    <label className="block mb-1">Email</label>
                    <input
                        className="w-full border p-2 rounded-sm"
                        type="text"
                        required
                    />
                </div>
                <div>
                    <label className="block mb-1">Adresse - Rue / Numéro</label>
                    <input className="w-full border p-2 rounded-sm" type="text" />
                </div>
                <div className="flex space-x-2">
                    <div className="w-1/3">
                        <label className="block mb-1">Code postal</label>
                        <input
                            className="w-full border p-2 rounded-sm"
                            type="text"
                        />
                    </div>
                    <div className="w-2/3">
                        <label className="block mb-1">Ville</label>
                        <input
                            className="w-full border p-2 rounded-sm"
                            type="text"
                        />
                    </div>
                </div>
                <div>
                    <label className="block mb-1">Pays</label>
                    <input className="w-full border p-2 rounded-sm" type="text" />
                </div>

                {/* Rattachement à un projet */}
                <div>
                    <label className="block mb-1">Projets rattachés</label>
                    <select multiple className="w-full border p-2 rounded-sm">
                        <option>Projet Alpha</option>
                        <option>Projet Beta</option>
                        <option>Projet Gamma</option>
                        <option>Projet Delta</option>
                        <option>Projet Événement Spécial</option>
                    </select>
                </div>
                <div>
                    <label className="block mb-1">Né(e) le</label>
                    <input className="w-full border p-2 rounded-sm" type="date" />
                </div>
                <div>
                    <label className="block mb-1">Sexe</label>
                    <select className="w-full border p-2 rounded-sm" required>
                        <option>Masculin</option>
                        <option>Féminin</option>
                        <option>Autres</option>
                    </select>
                </div>
                <div>
                    <label className="block mb-1">Type</label>
                    <select className="w-full border p-2 rounded-sm" required>
                        <option>Intervenant RMN</option>
                        <option>Intervenant EPV</option>
                        <option>Intervenant Extérieur</option>
                        <option>Structures</option>
                        <option>Personnel EPV</option>
                    </select>
                </div>
                <div>
                    <label className="block mb-1">Géré par</label>
                    <select className="w-full border p-2 rounded-sm" required>
                        <option>Médiation</option>
                        <option>SGP</option>
                        <option>RMN-GP</option>
                    </select>
                </div>
                <div>
                    <label className="block mb-1">Langues</label>
                    <select className="w-full border p-2 rounded-sm" required>
                        <option>Français</option>
                        <option>Anglais</option>
                        <option>Allemand</option>
                        <option>Espagnol</option>
                        <option>Italien</option>
                        <option>Chinois</option>
                        <option>Portugais</option>
                        <option>Russe</option>
                        <option>LSF</option>
                        <option>BSL</option>
                    </select>
                </div>
                <div>
                    <label className="block mb-1">Publics</label>
                    <select
                        multiple
                        className="w-full border p-2 rounded-sm"
                        required
                    >
                        <option>Individuels</option>
                        <option>Abonnés</option>
                        <option>Famille</option>
                        <option>Groupes Adultes</option>
                        <option>Crèche</option>
                        <option>Cycle 1 (3-5 ans)</option>
                        <option>Cycle 2 (6-9 ans)</option>
                        <option>Cycle 3 (9-12 ans)</option>
                        <option>Cycle 4 (12-15 ans)</option>
                        <option>Lycée (15+)</option>
                        <option>Scolaire supérieur</option>
                        <option>Public éloigné (générique)</option>
                        <option>Public éloigné adulte</option>
                        <option>Public éloigné jeune</option>
                        <option>Public éloigné famille</option>
                        <option>Apprenant langue française</option>
                        <option>Public empêché (sous main de justice)</option>
                        <option>Public handicap moteur</option>
                        <option>Public handicap auditif</option>
                        <option>Public handicap visuel</option>
                        <option>Public handicap psychique</option>
                        <option>Public handicap mental</option>
                        <option>Public empêché hospitalisé</option>
                        <option>Jeune Public</option>
                    </select>
                </div>
                {/* Photo */}
                <div>
                    <label className="block mb-1">Photo</label>
                    <input
                        className="w-full border p-2 rounded-sm"
                        type="file"
                        accept="image/*"
                    />
                </div>

                {/* Commentaire */}
                <div>
                    <label className="block mb-1">Commentaire</label>
                    <textarea
                        className="w-full border p-2 rounded-sm"
                        rows={3}
                        placeholder="Commentaire libre…"
                    />
                </div>
                <div className="text-right">
                    <button
                        type="button"
                        onClick={onClose}
                        className="mt-4 px-4 py-2 bg-gray-200 rounded-sm hover:bg-gray-300"
                    >
                        Fermer
                    </button>
                </div>
            </form>
        </div>
    );
};
